export default "__VITE_ASSET__DkJfzzNL__"